// extracted by mini-css-extract-plugin
export var blue = "_27-f";
export var brand = "_27-b";
export var darkGrey = "_27-e";
export var disabled = "_27-4";
export var disabledSubtle = "_27-5";
export var error = "_27-6";
export var green = "_27-g";
export var grey = "_27-d";
export var icon = "_27-0";
export var inherit = "_27-a";
export var lightGrey = "_27-c";
export var orange = "_27-i";
export var pink = "_27-k";
export var primary = "_27-1";
export var purple = "_27-l";
export var red = "_27-j";
export var secondary = "_27-2";
export var success = "_27-9";
export var tertiary = "_27-3";
export var warning = "_27-7";
export var warningSecondary = "_27-8";
export var white = "_27-m";
export var yellow = "_27-h";